import React from "react";
import { Box, Button, Divider, Stack, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import CustomButton from "../components/CustomButton";

const Home = () => {
  const navigate = useNavigate();

  function LoginHandleClick() {
    navigate("/dashboard");
  }

  function codeHandleClick() {
    navigate("/EnterCode");
  }

  return (
    <Box className="max_container">
      {/* <h1 className="text-[64px] font-medium text-center text-white">Song Requests</h1> */}
      <Divider sx={{ height: 100 }}/>
      <img src="/logo.png" alt="logo" className="mx-auto"/>
      <Stack spacing={2} className="my-36">
        <Button
          onClick={LoginHandleClick}
          variant="contained"
          color="primary"
          size="large"
          sx={{ padding: 1.3 }}
          startIcon={<Person2OutlinedIcon />}>
          Dj Login
        </Button>
        <Button
          onClick={codeHandleClick}
          variant="contained"
          color="primary"
          size="large"
          sx={{ padding: 1.3 }}>
          Join Event
        </Button>
      </Stack>
    </Box>
  );
};

export default Home;